import { useLoadingCatalogLang } from './useLoadingCatalogLang';

export function useLoadingCatalog() {
  const lang = useLoadingCatalogLang();
  return {
    lang,
  };
}
